import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { SEOHead } from "@/components/seo/SEOHead";
import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Track 404 errors without console logging
  }, [location.pathname]);

  return (
    <>
      <SEOHead
        title="404 - Page Not Found"
        description="The page you're looking for doesn't exist."
        canonicalUrl={location.pathname}
        noindex={true}
      />
      <div className="flex min-h-screen flex-col items-center justify-center bg-background">
        <div className="text-center mb-auto pt-32">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <Button onClick={() => navigate('/play')} className="gap-2">
            <Home className="h-4 w-4" />
            Return to Game
          </Button>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
